import { History } from "history";

export const pushPathWithSearch = (history: History, path: string) => {
  const queryIndex = path.indexOf("?");
  if (queryIndex === -1) {
    history.push(path);
    return;
  }
  history.push({
    pathname: path.slice(0, queryIndex),
    search: path.slice(queryIndex),
  });
};
